import http from '@/plugins/http';
import ENDPOINTS from '@/constants/endpoints.constant';

/**
 * @returns {promise} Promise object containing all coverage
 */
export const getCoverage = () => http.get(ENDPOINTS.COVERAGE);
